import styled from 'styled-components'

export const MarkdownTextContainer = styled.span`
    display: block;
`
